import { render, staticRenderFns } from "./qm-button.vue?vue&type=template&id=dce2357e"
import script from "./qm-button.vue?vue&type=script&lang=js"
export * from "./qm-button.vue?vue&type=script&lang=js"
import style0 from "./qm-button.vue?vue&type=style&index=0&id=dce2357e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports